<template>
  <div>
    <v-row class="mx-4 mt-1">
      <v-col cols="12" md="6">
        <h2 class="text-left">Staff Monthly Attendance Details</h2>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>

    <v-row no-gutters>
      <!-- date-range,chart column -->
      <v-col cols="12" md="3" order-md="2"
        v-if="currentStaff && currentUser.privileges.canViewAllStaffsMonthlyAttendanceAnalytics"
      >
        <v-card class="px-2 py-3 mx-5 my-2">
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="dateRange"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <!-- Date-range picker -->
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="formattedDateRange"
                label="Date Range"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                class="rounded-input"
                outlined
                dense
              ></v-text-field>
            </template>
            <v-date-picker
              :min="startOfMonth"
              :max="endOfMonth"
              v-model="dateRange"
              no-title
              scrollable
              range
            >
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="menu = false">
                Cancel
              </v-btn>
              <v-btn text color="primary" @click="getStaffAttendanceAnalytics()">
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>

          <!-- Attendance chart -->
          <div class="d-flex justify-center" v-if="chartData && checkChartData()">
            <StaffAttendanceAnalytics
              :series="[this.chartData.total_present_days, this.chartData.total_OT_days,this.chartData.paid_leaves, this.chartData.unpaid_leaves, this.chartData.total_absent_days ,this.chartData.half_days, this.chartData.holidays, this.chartData.weekoffs]"
              :labels="['Total Present','Total Overtime Days','Total Paid Leave', 'Total Unpaid Leave', 'Total Absent Days' ,'Total Half Day', 'Total Holiday', 'Total Weekly-off']"
              :colors="['#4CD137','pink' ,'#ff9800', '#FF0000','#800000', '#fdd835', '#2196f3', '#6a0dad']"
            />
          </div>

          <!-- stats below the chart -->
          <div class="mt-3" v-if="chartData">
            <div>
              <p class="font-weight-medium text-left mx-4 mb-1">
                 <strong>Total Working Days: {{chartData.working_days || '-' }}</strong>
              </p>
            </div>
            <v-divider></v-divider>
            <div>
              <p class="font-weight-medium text-left mx-4 mb-1">
               Total Present Days: {{ chartData.total_present_days || '-' }}
              </p>
            </div>
            <div>
              <p class="text--darken-4 font-weight-medium text-left mx-4 mb-1">
                Total Absent: {{ chartData.total_absent_days || '-'}}
              </p>
            </div>
            <div>
              <p class="font-weight-medium text-left mx-4 mb-1">
                Total Overtime: {{ chartData.total_OT_days || '-'}}
              </p>
            </div>
            <div>
              <p class="darken-3 font-weight-medium text-left mx-4 mb-1">
                Total Paid Leaves: {{ chartData.paid_leaves || '-' }}
              </p>
            </div>
            <div>
              <p class="text--darken-1 font-weight-medium text-left mx-4 mb-1">
                Total Unpaid Leaves: {{ chartData.unpaid_leaves || '-'}}
              </p>
            </div>
            <div>
              <p class="text--darken-1 font-weight-medium text-left mx-4 mb-1">
                Total Half Days: {{ chartData.half_days || '-' }}
              </p>
            </div>
            <div>
              <p class="font-weight-medium text-left mx-4 mb-1">
                Total Holiday: {{ chartData.holidays || '-' }}
              </p>
            </div>
            <div>
              <p class="font-weight-medium text-left mx-4 mb-1">
                Total Weekly-Off: {{ chartData.weekoffs || '-' }}
              </p>
            </div>
          </div>
        </v-card>
      </v-col>

      <v-col  order-md="1">
        <v-card class="ma-5">
          <v-row class="mx-4">
            <!-- column for staff names dropdown -->
              <v-col cols="12" md="4" class="my-1">
                <div>
                  <v-autocomplete
                    dense
                    filled
                    rounded
                    solo
                    :items="ownView"
                    label="Select Staff"
                    class="mt-4 font-weight-bold"
                    item-value="id"
                    item-text="full_name"
                    hide-details
                    return-object
                    v-model="currentStaff"
                    @change="getAttendanceFromId();handleTour();"
                  >
                    <template v-slot:item="data">
                      <template>
                        <v-list-item-content>
                          <v-list-item-title v-html="data.item.full_name"></v-list-item-title>
                          <v-list-item-subtitle
                            v-html="data.item.username + (data.item.employee_id? ` (${data.item.employee_id})` : '') "
                          ></v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                    </template>
                  </v-autocomplete>
                </div>
              </v-col>
            <!-- column for tooltip -->
            <v-col cols="12" md="5" sm="12" class="my-6">
              <!-- get previous month btn -->
              <div class="" v-if="currentStaff">
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      text
                      @click="decrement"
                    >
                      <v-icon>mdi-chevron-left</v-icon>
                    </v-btn>
                  </template>
                  <span>Previous Month</span>
                </v-tooltip>
                <!-- month, year display -->
                <span class="primary--text mx-n2"><b>{{ moment(current_month_year.month,"MM").format('MMMM') }}, {{ current_month_year.year }} </b></span>
                <!-- get next month btn -->
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="increment"
                      color="primary"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      text
                    >
                      <v-icon>mdi-chevron-right</v-icon>
                    </v-btn>
                  </template>
                  <span>Next Month</span>
                </v-tooltip>
              </div>
            </v-col>
            <!-- column for export btn -->
            <v-col cols="12" md="3" align-self="center">
              <div v-if="currentUser.privileges.canExportAllStaffsMonthlyAttendanceEntries">
                <!-- Export button -->
                <download-excel
                  :fetch="getExportData"
                  :fields="export_fields"
                  :name="getExportName()"
                  v-if="currentStaff"
                >
                  <v-btn
                    class="text-right"
                    :loading="export_in_progress"
                    :disabled="export_in_progress"
                    color="white"
                    elevation="2"
                  >
                    Export
                    <v-icon right dark> mdi-export </v-icon>
                  <template v-slot:loader>
                    <span class="custom-loader">
                      <v-icon light>mdi-cached</v-icon>
                    </span>
                  </template>
                  </v-btn>
                </download-excel>
              </div>
            </v-col>
          </v-row>

          <v-row class="my-3" align-self="center">
            <v-spacer></v-spacer>
          </v-row>
            
          <!-- Data table -->
          <v-data-table
            :headers="headers"
            :items-per-page="40"
            hide-default-footer
            disable-pagination
            :items="attendanceEntries"
            class="my-1 pb-5 font-weight-medium elevation-1 row-pointer"
            :single-expand = "true"             
            :expanded="expanded" 
            item-key="day"
            show-expand
            @click:row="clickedRow"
            v-if="this.currentStaff"
          >
            <template v-slot:item.status="{ item }">
              <v-chip 
                v-if="(moment(new Date()).format('DD/MM/YYYY') == moment(item.day + '/' + item.month + '/' + item.year, 'DD/MM/YYYY').format('DD/MM/YYYY') 
                && (item.status=='A' || item.status=='HD'))" 
                class="black--text" color="rgba(0,0,0,0)"> 
                <span> - </span>
              </v-chip>
              <v-chip small v-else-if="item.status" :class="style_mapping[item.status].class" :color="style_mapping[item.status].color"> 
                <span> {{ getStatusName(item.status) }}</span>
              </v-chip>
              <v-chip v-else class="black--text" color="rgba(0,0,0,0)"> 
                <span> - </span>
              </v-chip>
            </template>
            <template v-slot:item.first_in="{ item }">
              {{ item.first_in ? moment(item.first_in).format('LT'):'-' }}
              <span v-if="item.is_late" class="red--text">
                (L)
              </span>
            </template>
            <template v-slot:item.last_out="{item}">
              {{ item.last_out ? moment(item.last_out).format('LT'):'-' }}
            </template>
            <template v-slot:item.date="{item}">
              <!-- {{ moment(item.day + "/" + item.month + "/" + item.year, 'DD/MM/YYYY').format("DD/MM/YYYY") }} -->
              <span 
                v-if="moment(new Date()).format('DD/MM/YYYY') == moment(item.day + '/' + item.month + '/' + item.year, 'DD/MM/YYYY').format('DD/MM/YYYY')"
                style='color: rgb(32, 212, 32); font-weight: bolder;'
              >
                  {{moment().year(item.year).month(item.month-1).date(item.day).format('ddd, MMM DD, YYYY')}}
              </span>
              <span v-else>
                  {{moment().year(item.year).month(item.month-1).date(item.day).format('ddd, MMM DD, YYYY')}}
              </span>
            </template>
            <template v-slot:item.total_hours="{item}">
              {{ item.total_hours ? item.total_hours : '-' }}
            </template>
            <template v-slot:item.overtime="{item}">
              {{ item.overtime ? item.overtime : '-' }}
            </template>
            
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                <v-row v-for="entry in item.entries" :key="entry.id" class="my-2">
                  <v-col cols="6" md="3">
                    <p class="mb-1">In Time</p>
                    <p class="">
                      <b>{{ moment(entry.in_datetime).format('LT') }}</b>
                    </p>
                  </v-col>
                  
                  <v-col cols="6" md="3">
                    <p class="mx-2 mb-1">Out Time</p>
                    <p class="mx-2">
                      <b>{{ entry.out_datetime ? moment(entry.out_datetime).format('LT') : '-' }}</b>
                    </p>
                  </v-col>

                  <v-col
                    cols="12"
                    md="3"
                  >
                    <p class="mx-2 mb-1">Notes (optional)</p>
                    <p class="mx-2">
                      <b>{{ entry.notes ? entry.notes : '-' }}</b>
                    </p>
                  </v-col>

                  <v-col cols="12" md="2">
                    <div class="py-3">
                      <!-- edit entry -->
                      <v-icon
                        v-if="currentUser.privileges.canEditMonthlyStaffAttendanceEntries"
                        size="26"
                        class="mr-7 blue--text text--darken-4"
                        @click="editEntry(item, entry)"
                      >
                        mdi-pencil
                      </v-icon>
                      <!-- add new entry -->
                      <v-icon
                        v-if="currentUser.privileges.canDeleteMonthlyStaffAttendanceEntries"
                        size="26"
                        class="red--text text--darken-2"
                        @click="deleteEntry(item, entry)"
                      >
                        mdi-delete
                      </v-icon>
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <v-divider></v-divider>
                  </v-col>
                </v-row>
                <v-row>
                  <!-- Add entry btn -->
                 <v-col cols="12" class="" justify="center" v-if="currentUser.privileges.canAddMonthlyStaffAttendanceEntries">
                    <v-dialog
                      content-class="hideScroll"
                      v-model="showDialog" 
                      max-width="650px"
                      transition="none"
                      translate="none"
                      persistent
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          color="primary"
                          elevation="2"
                          v-bind="attrs"
                          v-on="on"
                          @click="addEntry(item)"
                          class="my-2"
                        >
                          Add Entry
                        </v-btn>
                      </template>
                      <!-- Add/Edit dialog component -->
                      <StaffAttendanceDialog @closeDialog="closeDialog()" @apiResponse="displayEntries" :entry_data="entry_data" :currentStaff="currentStaff" class="mb-2"/>
                    </v-dialog>
                  </v-col>
                </v-row>
              </td>
          </template>
          </v-data-table>
          <v-spacer></v-spacer>
          <div v-if="this.currentStaff" class="my-3"></div>
            <!-- default text when no staff selected -->
          <v-row class="">
              <v-col
                v-if="!this.currentStaff"
                class="black--text font-weight-bold"
              >
                Please select a staff name to get attendance data
              </v-col>
            </v-row>
        </v-card>
      </v-col>
    </v-row>

    <!-- Delete Entry dialog-box -->
    <DeleteEntryDialog
			title="The attendance entry for this staff will be deleted!"
			description="Are you sure you want to delete this entry? This cannot be reverted."
			:visible="showDeleteConfirmation"
      @deleteEntry="deleteConfirmation"
		/>

    <!-- snackbar -->
    <v-snackbar v-model="snackbar.visible">
			{{ snackbar.text }}
			<template>
				<v-btn color="pink" text @click="snackbar.visible = false">Close</v-btn>
			</template>
		</v-snackbar>
  </div>
</template>

<script>
import moment from "moment";
import StaffAttendanceAnalytics from "@components/staff_attendance/StaffAttendanceAnalytics.vue";
import StaffAttendanceDialog from "@components/staff_attendance/StaffAttendanceDialog.vue";
import api from "@api/index";
import { mapActions, mapGetters } from "vuex";
import JsonExcel from "vue-json-excel";
import endpoints from "@api/repository";
import DeleteEntryDialog from '../../components/staff_attendance/DeleteEntryDialog.vue';
import TourHelper from "@utils/tour_helper";


export default {
  name: "StaffMonthlyAttendance",
  components: {
    StaffAttendanceAnalytics,
    StaffAttendanceDialog,
    DeleteEntryDialog,
    downloadExcel: JsonExcel
  },
  props: ["staff_id", "month_id", "year_id", "apiResponse"],   // month_id, year_id accepted via props from StaffAttendanceDetail 
  
  data() {
    return {
      moment: moment,
      dateRange: null,  // store start,end date
      startOfMonth: null, // start date of the month,year
      endOfMonth: null,  // end date of the month,year
      menu: false,
      current_month_year: {   // store current month,year
        month: null,
        year: null,
      },

      snackbar: {
        visible: false,
        text: "",
      },

      showDeleteConfirmation: false,  // toggle for delete popup

      showDialog: false,
      expanded: [],
      // staffDetails: [],
      currentStaff: null,
      export_in_progress: false,
      export_fields: {
        "Date" : "date",
        "First in" : "first_in",
        "Last out" : "last_out",
        "Total Hours" : "total_hours",
        "Overtime" : "overtime",
        "Status" : "status"
      },

      chartData: null,
      
      // styles for v-chip
      style_mapping:{
        "A": {
          "class":"px-5 white--text",
          "color": "red"
        },
        "UL":{
          "class":"px-7 white--text",
          "color": "pink darken-1"
        },
        "P":{
          "class":"px-5 white--text",
          "color": "green"
        },
        "H":{
          "class":"px-6 white--text",
          "color": "blue"
        },
        "PL":{
          "color": "orange",
          "class": "px-6 white--text"
        },
        "HD":{
          "color": "yellow",
          "class":"px-5 white--text"
        },
        "OT": {
          "color": "green darken-1",
          "class":"px-5 white--text"
        },
        "W": {
          "color": "purple darken-1",
          "class": "px-4 white--text"
        },
        "-":{
          "color": "rgba(0,0,0,0)",
          "class": "black--text"
        },
      },

      staffData: [],
      entry_data: {
        date: null, 
        notes: null,
        inTime: null,
        outTime: null,
        is_editing: false,
      },
      attendanceData: [], // attendance data will be stored here
      // headers for data table
      headers: [
        { text: 'Date', value: 'date', align: "center" , sortable: true , width: 170},
        { text: 'First in', value: 'first_in', align: "center" , sortable: true, },
        { text: 'Last out', value: 'last_out', align: "center" , sortable: true },
        { text: 'Total Hours', value: 'total_hours', align: "center" , sortable: true },
        { text: 'Overtime', value: 'overtime', align: "center" , sortable: true },
        { text: 'Status', value: 'status', align: "center" , sortable: true },
        { text: '', value: 'data-table-expand', align: "center" },
      ],
      
      attendanceEntries: [],

      currentItem: null,
      currentEntry: null
    };
  },

  computed: {
    formattedDateRange() {
      if (!this.dateRange) 
        return;

      var formatted = moment(this.dateRange[0]).format("D MMM, YYYY") + " - " + moment(this.dateRange[1]).format("D MMM, YYYY");
      return formatted;
    },

    ownView(){
      if(this.staffData.length == 0) return [];
      if(!this.currentUser.privileges.canViewAllStaffsMonthlyAttendanceEntries){
        return this.staffData.filter(x=>x.id == this.currentUser.id);
      }
      else
      return this.staffData;
    },

    ...mapGetters(["currentUser", "accessToken", "isLoading"]),
    apiEssentials() {
      return {
        accessToken: this.accessToken,
        handleErrorsFunction: this.handleApiErrors,
        setLoading: this.setLoading,
      };
    },
  },

  methods: {
    ...mapActions(["setLoading"]),

    handleTour() {
        var steps = [];
        steps.push({id: '1', title: "Staff Monthly Attendance", description: "Mark and view your daily attendance, add your daily entry with start and end time, you can add your entry by clicking at a row in data table", videoLink: "https://youtube.com"});
        // steps.push({id: '2', description: "verify your leave balance after filling information", el: '#allowed-leaves'});
        TourHelper.startTour(this, "staff__monthly", steps);
    },

    // handles api errors
    async handleApiErrors(err) {
      this.setLoading(false);
      if (err.response) {
        console.log(err.response);
        if(err.response.status == 406) {
          this.snackbar.text = err.response.data.message;
          this.snackbar.visible = true;
        }
      } else {
        this.snackbar.text = "Unknown error occurred";
        this.snackbar.visible = true;
      }
    },

    // complete attd status from status code
    getStatusName(status) {
      if(status == 'PL')
        return 'Paid Leave';
      else if(status == 'P')
        return 'Present';
      else if(status == 'HD')
        return 'Half Day';
      else if(status == 'UL')
        return 'Unpaid Leave';
      else if(status == 'H')
        return 'Holiday';
      else if(status == 'W')
        return 'Weekly-Off';
      else if(status == "OT")        
        return 'Overtime';
      else if(status == "A")
        return 'Absent';
      return '-';
    },

    // get staff attd data for chart display
    async getStaffAttendanceAnalytics() {
      var url = endpoints.getStaffAttendanceAnalytics;

      if(!this.dateRange) {   // if no date range is selected, fetch data for the entire month
        // this.getFirstAndLastDate();
        url += `?staff_id=${this.currentStaff.id}&start_date=${this.startOfMonth}&end_date=${this.endOfMonth}`;
        this.chartData =  await api.call(this.apiEssentials, url);
      }
      else {  // fetch data for the selected date range
        this.$refs.menu.save(this.dateRange); // save the selected dates
        url += `?staff_id=${this.currentStaff.id}&start_date=${this.dateRange[0]}&end_date=${this.dateRange[1]}`
        this.chartData =  await api.call(this.apiEssentials, url);
      }
    },

    checkChartData() {
      var count = 0;
      for(const item in this.chartData){
        if(this.chartData[item] == 0)
          count++;
      }

      if(count == Object.keys(this.chartData).length) {
        return false;
      }
      
      return true;
    },

    // export data in excel format
    async getExportData() {
      this.export_in_progress = true; //loading and disabling the button
      var response = [];
      for(var i=0; i< this.attendanceEntries.length; i++)
      {
        var temp = {};
        Object.assign(temp, this.attendanceEntries[i]);
        response.push(temp);
      }  
      response.forEach(data => {
        if(!data.overtime)
        data.overtime = '-';

        if(data.first_in)
          data.first_in = moment(data.first_in).format('LT');
        else
          data.first_in = '-';

        if(data.last_out)
          data.last_out = moment(data.last_out).format('LT');
        else
          data.last_out = '-';
            
        if(!data.total_hours)
        data.total_hours = '-';

        data.date = data.day + "/" + data.month + "/" + data.year;
      })

      this.export_in_progress = false;
      return response;
    },


    // name of file to be exported
    getExportName() {
      return "StaffMonthlyAttendance_"+this.currentStaff.full_name+"_"+moment(this.current_month_year.month,"MM").format('MMM')+this.current_month_year.year+'.xls';
    },

    // get staff details
    async getAllStaff(){
      var url = endpoints.getAllStaff + '?all=true';
      this.staffData = await api.call(this.apiEssentials, url);
      // this.getStaffDetails();
    },

    async getAllStaffAttendanceEntries(month = this.current_month_year.month, year = this.current_month_year.year) {

      this.current_month_year.month = month;
      this.current_month_year.year = year;
      this.attendanceEntries = [];
      var url = endpoints.getAllStaffAttendanceEntries;
      // // if(staff) {
        url += `?month=${month}&year=${year}&staff_id=${this.currentStaff.id}`;
        this.attendanceEntries = await api.call(this.apiEssentials, url);

        let num_days = new Date(year, month, 0).getDate();

        var attdData = [];
        for(var i=0;i<num_days;i++){
          attdData.push(0);
        }

        this.attendanceEntries.forEach(data => {
          attdData[data.day-1] = 1;
        });

        var attendanceEntriesCopy = this.attendanceEntries.map(data => {
              return data;
        });
        // eslint-disable-next-line no-unused-vars
        var j = 0;

        for(let i=0; i<num_days; i++){
          if(attdData[i] == 0)
          {
            this.attendanceEntries[String(i)] = {
              'day': i+1,
              'month': month, 
              'year': year,
              'entries': [],
              'first_in': null,
              'last_out': null,
              'total_hours': '-',
              'notes': '-',
              'status': '-',
              'overtime': '-',
            }
          }
          else
          {
            this.attendanceEntries[String(i)] = {};
            Object.assign(this.attendanceEntries[String(i)], attendanceEntriesCopy[j]);
            j++;
          }
        }
    },

    // form an object with all staff details ( staffDetails )
    // getStaffDetails() {
    //   this.staffData.results.forEach(data => {
    //       var temp = {};
    //       temp.name = data.full_name;
    //       temp.username = data.username;
    //       temp.employee_id = data.employee_id;
    //       temp.id = data.id;
    //       this.staffDetails.push(temp);
    //   })
    // },

    // form month,year string from month no, year
    findMonthYear(month, year) {
      let monthYearString = moment().month(month - 1).format("MMMM") + " " + String(year);
      return monthYearString;
    },

    // go to next month
    increment(){
      var incremented_date = moment(this.current_month_year.year + "/" + this.current_month_year.month,"YYYY/MM").add(1, "months");   // add one month
      this.current_month_year.month = Number(incremented_date.format('M'))
      this.current_month_year.year = incremented_date.year();
      this.expanded = [];   // close expandable row on switching staff/month,year
      this.dateRange = null
      this.chartData = null;
      this.getFirstAndLastDate();
      this.getAllStaffAttendanceEntries();
      this.getStaffAttendanceAnalytics();
    },

    // go to prev month
    decrement() {
      var decremented_date = moment(this.current_month_year.year + "/" + this.current_month_year.month,"YYYY/MM").subtract(1, "months");  // subtract one month
      this.current_month_year.month = Number(decremented_date.format('M'))
      this.current_month_year.year = decremented_date.year();
      this.expanded = [];   // close expandable row on switching staff/month,year
      this.dateRange = null
      this.chartData = null;
      this.getFirstAndLastDate();
      this.getAllStaffAttendanceEntries();
      this.getStaffAttendanceAnalytics();
    },

    // on clicking each expandable-rows
    clickedRow(value) {
      const index = this.expanded.indexOf(value);
      if (index === -1) {
        this.expanded = [];
        this.expanded.push(value);
      } else {
        this.expanded.splice(index, 1);
      }
    },


    // get first and last date of current month, year
    async getFirstAndLastDate() {
      this.startOfMonth = moment( this.current_month_year.year + '/' + this.current_month_year.month, "YYYY/MM ").clone().startOf('month').format('YYYY-MM-DD');
      this.endOfMonth = moment(this.current_month_year.year + '/' + this.current_month_year.month, "YYYY/MM ").clone().endOf('month').format('YYYY-MM-DD');
    },

    // get attendance data from id
    async getAttendanceFromId(staffId = this.currentStaff.id) {
      
      if(staffId && !this.currentStaff)   // if staff_id received via props from staff data router-link
      {
        for(var i=0; i<this.staffData.length; i++)
        {
          if(staffId == this.staffData[i].id)
          {
            this.currentStaff = {'id': staffId, 'full_name': this.staffData[i].full_name};
            break;
          }  
        }
      }

      var url = endpoints.getStaffAttendance + `?staff_id=${staffId}`;
      this.attendanceData = await api.call(this.apiEssentials, url);  // api call to get attendance data

      // check if month, year received via props
      if(this.month_id && this.year_id)
        this.getAllStaffAttendanceEntries(this.month_id, this.year_id);
      else
        this.getAllStaffAttendanceEntries(); 
        
      this.expanded = [];   // close expandable row on switching staff/month,year
      this.dateRange = null;
      this.getStaffAttendanceAnalytics();
    },

    // add new attendance entry
    addEntry(item) {
      this.entry_data.date = moment(item.day+'/'+item.month+'/'+ item.year, 'DD/MM/YYYY').format('YYYY-MM-DD')
      this.showDialog = true;
    },

    // edit that attendance entry
    editEntry(item, entry) {
      this.entry_data = {
        date: moment(item.day+'/'+item.month+'/'+ item.year, 'DD/MM/YYYY').format('YYYY-MM-DD'),
        notes: entry.notes,
        inTime: moment(entry.in_datetime).format("HH:mm"),
        outTime: moment(entry.out_datetime).format("HH:mm"),
        is_editing: true,
        id: entry.id,
      }
      this.showDialog = true;
    },

    // check delete popup cancel/delete events
    async deleteConfirmation(confirm) {
      if(!confirm) {
        this.showDeleteConfirmation = false;
      }
      else {
        let url = endpoints.deleteStaffAttendanceEntries + `${this.currentEntry.id}/`;
        let response = await api.call(this.apiEssentials, url, api.Methods.DELETE);
        if(response) {
          var day = this.currentItem.day;
          Object.assign(this.attendanceEntries[day-1], response);
          this.currentItem = null;
          this.currentEntry = null;
          this.showDeleteConfirmation = false;
          this.getStaffAttendanceAnalytics()
        }
      }
    },

    // delete that attendance entry 
    deleteEntry(item, entry) {
      this.currentItem = item;
      this.currentEntry = entry;
      this.showDeleteConfirmation = true;      
    },
    
    // close the dialog and empty the values
    closeDialog() {
      this.showDialog = false;
      this.entry_data = {
        date: null,
        notes: null,
        inTime: null,
        outTime: null,
        is_editing: false
      }
    },

    // show new entry in the table as soon as it is logged (reactivity)
    displayEntries(apiResponse) {
      Object.assign(this.attendanceEntries[String(apiResponse.day - 1)], apiResponse);
      this.getStaffAttendanceAnalytics()
    },
  },

  async created() {
    this.current_month_year.month = new Date().getMonth() + 1
    this.current_month_year.year = new Date().getFullYear()
    
    // get staff details through api
    await this.getAllStaff();

    if(this.staff_id) // if staf_id received via prop, fetch data immediately
    {
      this.getAttendanceFromId(this.staff_id);
    }

    this.getFirstAndLastDate();
    this.dateRange = null;
    // this.handleTour();
  },
};
</script>

<style scoped>
  .data {
    text-align: start;
    vertical-align: middle;
  }
 
  .headers {
    text-align: start;
    font-weight: bolder;
    color: #000000;
    vertical-align: middle;
  }
  
  h2 {
    font-size: 24px;
  }
  
  .row-pointer {
    cursor: pointer;
  }
</style>

<style>
  .hideScroll{
    overflow: hidden !important;
    padding: 10px;
    box-shadow: none;
    border-radius: 4px;
    transition: none;
  }
</style>